<template>
  <div class="liquor-food-wine">
    <Header active="/liquor/browser" />
    <HeaderSelect active="browser" :list="headerSelectArray" />
    <NoContent />
    <Sticky />
  </div>
</template>

<script>
import Header from "@/components/liquor/Header";
import HeaderSelect from "@/components/liquor/HeaderSelect";
import Sticky from "@/components/liquor/Sticky";

import NoContent from "@/components/common/NoContent";

export default {
  name: "LiquorBrowser",
  components: {
    Header,
    HeaderSelect,
    NoContent,
    Sticky
  },
  data() {
    return {
      headerSelectArray: [
        {
          name: "商品一览",
          link: "/liquor/browser",
          active: false
        },
        {
          name: "配餐配酒",
          link: "/liquor/food-wine",
          active: true
        },
        {
          name: "品鉴美学",
          link: "/liquor/tasting",
          active: false
        }
      ]
    };
  }
};
</script>

<style lang="scss">
.liquor-food-wine {
  width: 100%;
  margin-top: 160px;
}
</style>

<style lang="scss" scoped>
.liquor-food-wine {
  .liquor-header-parent {
    background: rgba(0, 0, 0, 1);
  }
}
</style>